import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initScrollTrigger() {
  document.querySelectorAll("[data-trigger]").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 80%",

      toggleClass: {
        targets: el,
        className: "InView",
      },

      once: true,
    });
  });
}
